import { create } from 'zustand';
import { Queue, type IQueue } from '@/util/queue';
import { AlertMode } from '@/components/Alert/types';

const SLIDE_DELAY = 400;

export interface AlertDescriptor {
    mode: AlertMode;
    generalMessage: string;
    detailMessage: string;
}

export interface AlertState {
    descriptor: AlertDescriptor;
    showing: boolean;
    pending: IQueue<AlertDescriptor>;
    show: (descriptor: AlertDescriptor) => void;
    hide: VoidFunction
}

export const useAlert = create<AlertState>((set, get) => ({
    descriptor: {
        mode: AlertMode.INFO,
        generalMessage: "",
        detailMessage: ""
    },
    showing: false,
    pending: new Queue<AlertDescriptor>(),
    show: (descriptor: AlertDescriptor) => {
        const { pending, showing } = get();
        if (showing) {
            pending.enqueue(descriptor);
        } else {
            setTimeout(() => {
                set({
                    descriptor: descriptor,
                    showing: true
                })

            }, SLIDE_DELAY);
        }
    },
    hide: () => {
        set(() => ({ showing: false }));
        const { pending, show } = get();
        if (pending.size > 0) {
            const next = pending.dequeue();
            if (next) {
                show(next);
            }
        }
    }
}));